/**
 * Compares two dotted version strings ("26.7.1").
 * Returns 1 if a > b, -1 if a < b, 0 if equal. Missing segments count as 0,
 * non-numeric suffixes ("1-rc1") are ignored.
 */
export function compareVersions(a, b) {
  if (a === b) return 0;

  const toSegments = version =>
    String(version ?? "")
      .split(".")
      .map(segment => parseInt(segment, 10) || 0);

  const pa = toSegments(a);
  const pb = toSegments(b);
  const len = Math.max(pa.length, pb.length);

  for (let i = 0; i < len; i++) {
    const na = pa[i] ?? 0;
    const nb = pb[i] ?? 0;
    if (na > nb) return 1;
    if (na < nb) return -1;
  }

  return 0;
}
